export default "__VITE_ASSET__CKiUwgDY__"